import React, { useMemo } from "react";
import {
	Container,
	ModuleContainer,
	Section,
	SubGrid,
	DetailHead,
	DetailHeadLeft,
	DetailIconWrap,
	DetailEyebrow,
	DetailTitle,
	DetailDesc,
	CardIconWrap,
	CardTitle,
	CardDesc,
	CardArrow,
} from "./styles";
import {
	MdFormatListBulleted,
	MdMobileScreenShare,
	MdOutlineChecklist,
	MdOutlineDeveloperMode,
	MdOutlinePlace,
} from "react-icons/md";
import { Link } from "react-router-dom";
import {
	CalendarOutlined,
	SettingOutlined,
	SnippetsOutlined,
	UserSwitchOutlined,
} from "@ant-design/icons";
import { BiCoinStack, BiImport } from "react-icons/bi";
import { TbDeviceMobile, TbTransferOut } from "react-icons/tb";
import { FaHeadset } from "react-icons/fa";
import { COLORS } from "../../../../../layout/theme";

export default function ModuleErp({
	userdata,
	userRol,
	toValidateQty,
	activeSection,
}) {
	const generalItems = useMemo(
		() => [
			{
				to: "/admin/marketRoutes?uri=generalConfig",
				title: "Rutas laboratorios",
				desc: "Administración de rutas y cobertura",
				icon: <MdOutlinePlace size={16} />,
			},
			{
				to: "/admin/marketWebSellers?uri=generalConfig",
				title: "Dinámicas callcenter",
				desc: "Gestión de dinámicas y operación de callcenter",
				icon: <FaHeadset size={16} />,
			},
			{
				to: "/admin/expoEventOT?uri=generalConfig",
				title: "Eventos",
				desc: "Configuración y administración de eventos",
				icon: <CalendarOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/distributorResponseCT?uri=generalConfig",
				title: "Carga detalle pedidos",
				desc: "Carga y seguimiento del detalle de pedidos",
				icon: <SnippetsOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/orderStateCT?uri=generalConfig",
				title: "Estado general pedidos",
				desc: "Monitoreo del estado global de pedidos",
				icon: <TbTransferOut size={16} />,
			},
		],
		[],
	);

	const productsItems = useMemo(
		() => [
			{
				to: "/admin/marketProductsIndex?uri=generalConfig",
				title: "Productos",
				desc: "Administración de productos disponibles",
				icon: <MdOutlineChecklist size={16} />,
			},
			{
				to: "/admin/import?uri=generalConfig",
				title: "Importadores",
				desc: "Importación masiva de productos y datos",
				icon: <BiImport size={16} />,
			},
		],
		[],
	);

	const mobileItems = useMemo(
		() => [
			{
				to: "/admin/marketUserRoutes?uri=generalConfig",
				title: "Rutas usuarios",
				desc: "Asignación y administración de rutas",
				icon: <UserSwitchOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/marketProductDiscounts?uri=generalConfig",
				title: "Dinámicas Mobile",
				desc: "Reglas y dinámicas comerciales para mobile",
				icon: <BiCoinStack size={16} />,
			},
			{
				to: "/admin/marketUserDiscounts?uri=generalConfig",
				title: "Dinámicas vendedores mobile",
				desc: "Configuración de dinámicas",
				icon: <TbDeviceMobile size={16} />,
			},
			{
				to: "/admin/marketMobileConfigs?uri=generalConfig",
				title: "Configuraciones mobile",
				desc: "Configuracion visual de la aplicación mobile",
				icon: <SettingOutlined style={{ fontSize: 16 }} />,
			},
		],
		[],
	);

	const panel =
		activeSection === "products"
			? {
					eyebrow: "Productos",
					title: "Gestión de Productos",
					desc: "Sección para administrar productos e importaciones",
					icon: <MdFormatListBulleted size={20} />,
					iconBg: COLORS.LightSecondary, //"#E1F5EE",
					iconColor: COLORS.Secondary, //"#0F6E56",
					items: productsItems,
				}
			: activeSection === "mobile"
				? {
						eyebrow: "Mobile",
						title: "Aplicación Mobile",
						desc: "Sección para administrar configuración y dinámicas mobile",
						icon: <MdMobileScreenShare size={20} />,
						iconBg: COLORS.LightPrimary, //"#FAEEDA",
						iconColor: COLORS.Primary, //"#854F0B",
						items: mobileItems,
					}
				: {
						eyebrow: "Configuración General",
						title: "ERP",
						desc: "Administra las aplicaciones y configuraciones generales del ERP",
						icon: <MdOutlineDeveloperMode size={20} />,
						iconBg: "#E6F1FB",
						iconColor: "#185FA5",
						items: generalItems,
					};

	return (
		<Section>
			<DetailHead>
				<DetailHeadLeft>
					<DetailIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
						{panel.icon}
					</DetailIconWrap>

					<div>
						<DetailEyebrow>{panel.eyebrow}</DetailEyebrow>
						<DetailTitle>{panel.title}</DetailTitle>
						<DetailDesc>{panel.desc}</DetailDesc>
					</div>
				</DetailHeadLeft>
			</DetailHead>

			<SubGrid>
				{panel.items.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<ModuleContainer>
							<Container>
								<CardIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
									{item.icon}
								</CardIconWrap>

								<CardTitle>{item.title}</CardTitle>
								<CardDesc>{item.desc}</CardDesc>
								<CardArrow>Acceder →</CardArrow>
							</Container>
						</ModuleContainer>
					</Link>
				))}
			</SubGrid>
		</Section>
	);
}
